import React from 'react';
import { mergeClassNames } from '../../../utils/mergeClassnames';
import Image from '../../generic/Image';
import styles from './index.module.scss';

export const Animation = {
  fade: 'fadeAnimation',
  pan: 'panAnimation',
};

export const ObjectFit = {
  cover: { objectFit: 'cover', objectPosition: 'center center' },
  contain: { objectFit: 'contain', objectPosition: 'center center' },
};

// shared between the different Gallery types
export function ImageContainer({
  slides,
  activeSlideIndex,
  className = '',
  style = {},
  children = undefined,
  animation = Animation.pan,
  objectFit = ObjectFit.cover,
}) {
  return (
    <ul className={mergeClassNames(styles.imagePosition, styles.animated, styles[animation], className)} style={style}>
      {slides.map((slide, index) => (
        <li className={mergeClassNames(styles[getPosition(index, activeSlideIndex)])} key={`${slide.id}-${index}`}>
          {slide.image?.fluid && (
            <Image fluid={slide.image.fluid} imgStyle={objectFit} className={mergeClassNames(styles.image)} />
          )}
          {children}
        </li>
      ))}
    </ul>
  );
}

const activeStyles = {
  predecessor: 'pred',
  current: 'cur',
  successor: 'succ',
  single: 'single',
};

export function getPosition(slideIndex, activeSlideIndex) {
  if (slideIndex === activeSlideIndex) return activeStyles.current;
  if (slideIndex < activeSlideIndex) return activeStyles.predecessor;
  if (slideIndex > activeSlideIndex) return activeStyles.successor;
}
